import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Stack from "@mui/material/Stack";
import DocumentDraftService from "../../services/DocumentDraftService";
import DraftItem from "./DraftItem";

const DraftsList = ({ estateId }) => {
  const [drafts, setDrafts] = useState([]);

  const getDrafts = async () => {
    try {
      const res = await DocumentDraftService.getByEstateId(estateId);
      setDrafts(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDrafts();
  }, []);

  return (
    <StyleWrapper className="drafts">
      <h5 className="draft-title">Brouillons</h5>
      <Stack gap={2} sx={{ maxHeight: "100%", overflowY: "auto" }}>
        {drafts.map((draft) => (
          <DraftItem draft={draft} refetch={getDrafts} />
        ))}
      </Stack>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.drafts {
    padding-bottom: 70px;
    height: 450px;
  }

  .draft-title {
    font-size: 26px;
    font-weight: 700;
    color: var(--text-color);
  }
`;

export default DraftsList;
